import React, { Component } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Header from "../Layouts/Header";
import MenuSidebar from "../Layouts/MenuSidebar";
import $ from "jquery";
import Select from "react-select";
import { lang } from "../Helpers/lang";
import { PageTitle, CheckAuth } from "../Helpers/SettingHelper";
import { apiUrl, tapURL, mediaUrl } from "../Config/Config";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";

const withRouter = (WrappedComponent) => (props) => {
  const params = useParams();
  const navigate = useNavigate();

  return <WrappedComponent {...props} params={params} navigate={navigate} />;
};

class Edit extends Component {
  constructor(props) {
    CheckAuth();
    super(props);
    const tabId = typeof props.params.ID === "undefined" ? "" : props.params.ID;

    this.state = {
      tabId: tabId,
      menu_name: "",
      trigger_page: "",
      user_type: "",
      priority: "",
      selSubmenuOption: "",
      selUserTypeOption: "",
      selSideMenuOption: "",
      Loading: false,
      selectedOption: { value: "active", label: "Active" },
      selectedvalue: "",
      selectedtype: "",
      selectedtypeValue: "",
      editid: 0,
      image_preview: "",
      image_name: "",
      image: "",
      tabFolder: "",
      old_image: "",
      fileExtension: "",
    };
    var qs = require("qs");
    var catid = this.state.tabId;
    var postObject = {
      id: this.state.tabId,
      admin_id: localStorage.getItem("admin_id"),
    };
    axios
      .post(apiUrl + "Submenumanagement/listdetail", qs.stringify(postObject))
      .then((res) => {
        console.log(res, "Submenumanagement");
        const triggerPageValue = res.data.tablist.trigger_page;
        const triggerUserType = res.data.tablist.user_type;
        const triggerSideMenu = res.data.tablist.trigger_tab;

        const matchedOption = lang.common.linkto_option.find(
          (opt) => opt.value === triggerPageValue
        );
        const matchedUserType = lang.common.userType_option.find(
          (opt) => opt.value === triggerUserType
        );

        const matchedSidemenu = lang.common.sidetabmenu_option.find(
          (opt) => opt.value === triggerSideMenu
        );

        this.setState({
          menu_name: res.data.tablist.menu_name,
          trigger_page: triggerPageValue,
          user_type: res.data.tablist.user_type,
          priority: res.data.tablist.priority,
          selSubmenuOption: matchedOption || { value: "", label: "Select" },
          selUserTypeOption: matchedUserType || { value: "", label: "Select" },
          selSideMenuOption: matchedSidemenu || { value: "", label: "Select" },
          selectedOption:
            res.data.tablist.status === "A"
              ? { value: "active", label: "Active" }
              : { value: "inactive", label: "Inactive" },
          selectedtypeValue: res.data.tablist.content_type,
          editid: 1,
          image_preview: res.data.tablist.image,
          old_image: res.data.tablist.image,
          preview: `${mediaUrl}submenu/${res.data.tablist.image}`,
        });
      });

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }
  handleTypeChange = (selectedOption) => {
    this.setState({ selectedtype: selectedOption });
    this.setState({ selectedtypeValue: selectedOption.value });
  };
  handleChange = (selectedOption) => {
    this.setState({ selectedOption });
    this.setState({ selectedvalue: selectedOption.value });
  };

  handleOptionChange = (selSubmenuOption) => {
    this.setState({ selSubmenuOption });
    this.setState({
      selSubmenuLabel: selSubmenuOption.label,
      selSubmenuValue: selSubmenuOption.value,
    });
  };

  handleUserTypeOptionChange = (selUserTypeOption) => {
    this.setState({ selUserTypeOption });
    this.setState({
      selUserTypeLabel: selUserTypeOption.label,
      selUserTypeValue: selUserTypeOption.value,
    });
  };

  handleSideMenuOptionChange = (selSideMenuOption) => {
    this.setState({ selSideMenuOption });
    this.setState({
      selSideMenuLabel: selSideMenuOption.label,
      selSideMenuValue: selSideMenuOption.value,
    });
  };

  handleInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  componentDidMount() {
    document.title = PageTitle("Tab Edit");
  }

  onChangeHandler = (event) => {
    let reader = new FileReader();
    const file = event.target.files[0];
    const extension = file.name.split(".").pop();
    reader.onloadend = () => {
      this.setState({
        image_name: file.name,
        image_preview: reader.result,
        image: file,
        fileExtension: extension,
        editid: 0,
      });
    };
    reader.readAsDataURL(file);
  };

  handleFormSubmit = () => {
    //   if (this.validateForm()) {
    this.setState({ Loading: true });

    const formPayload = this.state;
    var status = "";

    if (formPayload.selectedvalue === "" || formPayload.selectedvalue === 0) {
      status = formPayload.selectedOption?.value || "";
    } else {
      status = formPayload.selectedvalue;
    }

    var postObject = {
      admin_id: localStorage.getItem("admin_id"),
      name: formPayload.menu_name,
      priority: formPayload.priority,
      tigger_page: this.state.trigger_page,
      user_type: this.state.user_type,
      side_menu: this.state.selSideMenuOption?.value || "",
      status: status,
      editid: this.state.editid,
      old_image: this.state.old_image,
      image: formPayload.image || "",
      id: formPayload.tabId,
    };

    let formData = new FormData();
    Object.keys(postObject).forEach((key) => {
      if (postObject[key] !== undefined && postObject[key] !== null) {
        formData.append(key, postObject[key]);
      }
    });

    axios.post(apiUrl + "Submenumanagement/edit", formData).then((res) => {
      if (res.data.status === "success") {
        this.setState({ Loading: false });
        $(".success_message").html(
          '<div class="status_sucess"><h3>' + res.data.message + "</h3></div>"
        );
        setTimeout(
          function () {
            $(".success_message").html(
              this.props.navigate("/tabmenumanagement")
            );
          }.bind(this),
          3000
        );
      } else {
        $(".success_message").html(
          '<div class="status_sucess"><h3>' + res.data.message + "</h3></div>"
        );

        setTimeout(
          function () {
            $(".success_message").html("");
          }.bind(this),
          3000
        );
      }
    });
    //   }
  };

  //   validateForm() {
  //     const { selSubmenuValue, submenuName, priority } = this.state;

  //     let errors = {};
  //     let formIsValid = true;

  //     if (!submenuName) {
  //       formIsValid = false;
  //       $(".errorsubmenuName").html(
  //         '<span class="errorspan">Please fill the field</span>'
  //       );
  //     } else {
  //       $(".errorsubmenuName").html("");
  //     }

  //     if (!priority) {
  //       formIsValid = false;
  //       $(".errorpriority").html(
  //         '<span class="errorspan">Please fill the field</span>'
  //       );
  //     } else {
  //       $(".errorpriority").html("");
  //     }

  //     if (!selSubmenuValue) {
  //       formIsValid = false;
  //       $(".errorselSubmenuValue").html(
  //         '<span class="errorspan">Please fill the field</span>'
  //       );
  //     } else {
  //       $(".errorselSubmenuValue").html("");
  //     }

  //     this.setState({
  //       errors: errors,
  //     });
  //     return formIsValid;
  //   }

  render() {
    const { selectedOption, selSubmenuOption, selUserTypeOption } = this.state;
    return (
      <div className="wrapper">
        <Header />
        <MenuSidebar currentpage="tabmenumanagement"  currentTab="common"  />  
        <div className="content">
          <div className="content-wrapper">
            <div class="content-wrapper-before"></div>
            <div className="form-wrapper leaa-admin-head card">
              <div className="success_message"></div>
              <div className="title">
                <h4>Edit Tabmenu</h4>
              </div>
              <form
                className="edit"
                id="edit"
                onSubmit={(e) => {
                  this.handleFormSubmit(this);
                  e.preventDefault();
                }}
              >
                <div className="form-row">
                  <div className="form-left">
                    <div className="form-group">
                      <label>
                        Menu Name
                        <span class="required" style={{ color: "red" }}>
                          *{" "}
                        </span>{" "}
                        :{" "}
                      </label>
                      <input
                        type="text"
                        name="menu_name"
                        onChange={this.handleInputChange}
                        className="form-control"
                        value={this.state.menu_name || ""}
                      />
                      <div className="errorsubmenuName"></div>
                    </div>

                    <div className="form-group">
                      <label>
                        User Type
                        <span class="required" style={{ color: "red" }}>
                          {" "}
                          *{" "}
                        </span>{" "}
                        :
                      </label>
                      <Select
                        name="status"
                        value={this.state.selUserTypeOption}
                        options={lang.common.userType_option}
                        isSearchable={false}
                        onChange={(selected) => {
                          this.setState({
                            selUserTypeOption: selected,
                            user_type: selected.value,
                          });
                        }}
                      />
                      <div className="errorselSubmenuValue"></div>
                    </div>
                    <div className="form-group">
                      <label>Image (jpeg,jpg,png,svg)</label>
                      <div className="choose-file">
                        {this.state.isHidden && (
                          <div className="image_success"></div>
                        )}
                        <span className="profile_btn">
                          <input
                            type="file"
                            name="file"
                            onChange={this.onChangeHandler}
                          />
                        </span>
                      </div>

                      {this.state.editid === 1 && this.state.preview && (
                        <img
                          className="img_class"
                          src={this.state.preview}
                          alt="Preview"
                        />
                      )}

                      <div className="errorfile"></div>
                    </div>
                    <div className="form-group">
                      <label>
                        Status
                        <span class="required" style={{ color: "red" }}>
                          {" "}
                          *{" "}
                        </span>{" "}
                        :
                      </label>
                      <Select
                        name="status"
                        value={
                          selectedOption
                            ? selectedOption
                            : { value: "active", label: "Active" }
                        }
                        options={lang.common.status_option}
                        isSearchable={false}
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>

                  <div className="form-right">
                    <div className="form-group">
                      <label>
                        Link to
                        <span class="required" style={{ color: "red" }}>
                          {" "}
                          *{" "}
                        </span>{" "}
                        :
                      </label>
                      <Select
                        name="status"
                        value={this.state.selSubmenuOption}
                        options={lang.common.linkto_option}
                        isSearchable={false}
                        onChange={(selected) => {
                          this.setState({
                            selSubmenuOption: selected,
                            trigger_page: selected.value,
                          });
                        }}
                      />
                      <div className="errorselSubmenuValue"></div>
                    </div>
                    <div className="form-group">
                      <label>Side Menu :</label>
                      <Select
                        name="status"
                        value={this.state.selSideMenuOption}
                        options={lang.common.sidetabmenu_option}
                        isSearchable={false}
                        onChange={(selected) => {
                          this.setState({
                            selSideMenuOption: selected,
                            side_menu: selected.value,
                          });
                        }}
                      />
                      <div className="errorselSubmenuValue"></div>
                    </div>
                    <div className="form-group">
                      <label>Priority: </label>
                      <input
                        type="number"
                        name="priority"
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value.length <= 3) {
                            this.setState({ priority: value });
                          }
                        }}
                        className="form-control"
                        value={this.state.priority || ""}
                      />
                      <div className="errorpriority"></div>
                    </div>
                  </div>
                </div>
                <div className="btn-group export">
                  <button
                    className="btn btn_orange btn_minwid login_submit animate-btn2"
                    type="submit"
                    disabled={this.state.Loading === true ? true : false}
                  >
                    {" "}
                    {this.state.Loading === true ? (
                      <span>updating</span>
                    ) : (
                      <span>Submit</span>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(Edit);
